(() => {
  'use strict';

  const TABLES = [
    {
      selector: '.fg[data-fee-gap-page="public-v1-3-2"] #all-cities table.results',
      columns: { 0: 'number', 1: 'text', 2: 'number', 3: 'number', 4: 'text', 5: 'number' }
    },
    {
      selector: '.fg[data-fee-gap-page="verification-hub-v1"] .table-scroll table',
      columns: { 0: 'number', 1: 'text', 2: 'number' }
    }
  ];

  const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });

  function numericValue(text) {
    const match = String(text).replace(/,/g, '').match(/-?\d+(?:\.\d+)?/);
    return match ? Number(match[0]) : Number.POSITIVE_INFINITY;
  }

  function valueFor(row, columnIndex, type) {
    const text = row.cells[columnIndex]?.textContent.trim() || '';
    return type === 'number' ? numericValue(text) : text;
  }

  function enhanceTable(table, columns) {
    if (!table || table.dataset.sortEnhanced === 'true' || !table.tHead || !table.tBodies.length) return;

    const root = table.closest('.fg') || table.parentElement;
    const status = document.createElement('div');
    status.className = 'research-sort-status visually-hidden';
    status.dataset.researchSortStatus = '';
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');
    root.append(status);

    const hint = document.createElement('p');
    hint.className = 'research-sort-hint';
    hint.textContent = 'Select a column heading to sort the table.';
    table.parentElement.insertAdjacentElement('beforebegin', hint);

    const body = table.tBodies[0];
    const originalOrder = new Map(Array.from(body.rows).map((row, index) => [row, index]));
    let activeColumn = null;
    let direction = 'ascending';

    Object.entries(columns).forEach(([indexText, type]) => {
      const columnIndex = Number(indexText);
      const th = table.tHead.rows[0]?.cells[columnIndex];
      if (!th) return;

      const label = th.textContent.trim();
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'research-sort-button';
      button.dataset.researchSort = '';
      button.dataset.sortType = type;
      button.setAttribute('aria-label', `Sort by ${label}`);

      const text = document.createElement('span');
      text.textContent = label;
      const icon = document.createElement('span');
      icon.className = 'research-sort-icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.textContent = '↕';
      button.append(text, icon);

      th.textContent = '';
      th.append(button);
      th.dataset.columnIndex = String(columnIndex);
      th.setAttribute('aria-sort', 'none');

      button.addEventListener('click', () => {
        direction = activeColumn === columnIndex && direction === 'ascending' ? 'descending' : 'ascending';
        activeColumn = columnIndex;

        const rows = Array.from(body.rows);
        rows.sort((a, b) => {
          const av = valueFor(a, columnIndex, type);
          const bv = valueFor(b, columnIndex, type);
          let comparison = type === 'number' ? av - bv : collator.compare(av, bv);
          if (!Number.isFinite(comparison)) comparison = av === bv ? 0 : (av === Number.POSITIVE_INFINITY ? 1 : -1);
          if (comparison === 0) comparison = originalOrder.get(a) - originalOrder.get(b);
          return direction === 'ascending' ? comparison : -comparison;
        });
        rows.forEach(row => body.append(row));

        table.tHead.querySelectorAll('th[aria-sort]').forEach(header => {
          header.setAttribute('aria-sort', 'none');
          const headerButton = header.querySelector('[data-research-sort]');
          const headerIcon = headerButton?.querySelector('.research-sort-icon');
          if (headerButton) headerButton.setAttribute('aria-label', `Sort by ${headerButton.firstElementChild.textContent}`);
          if (headerIcon) headerIcon.textContent = '↕';
        });
        th.setAttribute('aria-sort', direction);
        icon.textContent = direction === 'ascending' ? '↑' : '↓';
        button.setAttribute('aria-label', `Sort by ${label}, currently ${direction}`);
        status.textContent = `Sorted by ${label}, ${direction}.`;
      });
    });

    table.dataset.sortEnhanced = 'true';
  }

  function init() {
    TABLES.forEach(config => document.querySelectorAll(config.selector).forEach(table => enhanceTable(table, config.columns)));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
